import { render } from "./HotelDetail.vue?vue&type=template&id=02a7fa30&scoped=true"
import script from "./HotelDetail.vue?vue&type=script&lang=js"
export * from "./HotelDetail.vue?vue&type=script&lang=js"

import "./HotelDetail.vue?vue&type=style&index=0&id=02a7fa30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a7fa30"]])

export default __exports__